import { FilePresent } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

import { Button, Messages, Spinner } from '@ifs-gcp/components';
import type { TranslationText } from '@ifs-gcp/core/models';

import { getTranslation } from '@/utils/translations';

import styles from './render-container.module.scss';

type RenderContainerProps = {
  isLoading: boolean;
  isError: boolean;
  translations: Record<string, TranslationText>;
  onGenerateReport: () => void;
};

export const RenderContainer = ({
  isLoading,
  isError,
  translations,
  onGenerateReport,
}: RenderContainerProps) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  return (
    <>
      {isError && (
        <Messages
          messages={[t('errors.error_occurred_description')]}
          type="error-box"
          variant="plain"
          headerText={t('common.error')}
        />
      )}
      <h4 className={styles.header}>{getTranslation(translations.header, language)}</h4>
      {isLoading ? (
        <Spinner />
      ) : (
        <Button variant="contained" color="secondary" onClick={onGenerateReport}>
          <FilePresent />
          {getTranslation(translations.generate_report, language)}
        </Button>
      )}
    </>
  );
};
